import React, { useEffect } from 'react';
import { Row, Col } from 'antd';
import { withRouter, useLocation } from 'react-router-dom';
import ZzalInfo from './Sections/ZzalInfo';

function DetailPage(props) {
  const location = useLocation();
  const zzalId = props.match.params.zzalId;
  const link = location.state.link;

  useEffect(() => {
    if (!link) props.history.push('/');
  }, []);

  const errorHandler = (e) => {
    e.target.src = `https://res.cloudinary.com/${process.env.REACT_APP_CLOUD_NAME}/image/upload/v1622789406/icon/zzal_tl6ooy_obtlyv.jpg`;
  };

  return (
    <div style={{ width: '100%', padding: '3rem 4rem', marginTop: '7rem' }}>
      <Row gutter={[16, 16]}>
        <Col lg={12} sm={24} style={{ textAlign: 'center' }}>
          <div
            style={{ display: 'inline-block', width: '400px', height: '400px' }}
          >
            <img
              id='zzal-img'
              style={{
                border: '1px solid #ccc',
                width: '100%',
                boxShadow: '0 4px 5px #ccc',
              }}
              src={link}
              alt='#'
              onError={errorHandler}
            />
          </div>
        </Col>
        <Col lg={12} sm={24} style={{ textAlign: 'center' }}>
          <ZzalInfo info={{ id: zzalId, link }} />
        </Col>
      </Row>
    </div>
  );
}

export default withRouter(DetailPage);
